import { render, staticRenderFns } from "./MContact.vue?vue&type=template&id=aa153cdc&scoped=true"
import script from "./MContact.vue?vue&type=script&lang=js"
export * from "./MContact.vue?vue&type=script&lang=js"
import style0 from "./MContact.vue?vue&type=style&index=0&id=aa153cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa153cdc",
  null
  
)

export default component.exports